import React from "react";
import { FaEnvelope, FaPhone, FaVideo } from "react-icons/fa";

const ContactOneInfoItem = (props) => {
  const { item } = props;

  const getIcon = () => {
    if (item.type === "email") {
      return <FaEnvelope />;
    } else if (item.type === "phone") {
      return <FaPhone />;
    } else if (item.type === "booking") {
      return <FaVideo />;
    }
    return null;
  };

  const getIconBgColor = () => {
    if (item.type === "email") {
      return "#17a2b8"; // Turquoise
    } else if (item.type === "phone") {
      return "#ffc107"; // Yellow
    } else if (item.type === "booking") {
      return "#564dca";
    }
    return "#17a2b8";
  };

  const handleContactClick = () => {
    if (item.type === "email") {
      // Open default email client
      window.location.href = `mailto:${item.contact}`;
    } else if (item.type === "phone") {
      // Initiate phone call
      window.location.href = `tel:${item.contact}`;
    } else if (item.type === "booking") {
      item.onClick();
    }
  };

  return (
    <div
      className="contact-info-item text-center"
      style={{
        backgroundColor: "rgba(33, 37, 41, 0.4)",
        borderRadius: "25px",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        padding: "2rem",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Icon */}
      <div
        className="icon mb-4"
        style={{
          width: "60px",
          height: "60px",
          borderRadius: "15px",
          backgroundColor: getIconBgColor(),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.5rem",
          color: "white",
        }}
      >
        {getIcon()}
      </div>

      {/* Title */}
      <h4
        className="text-white mb-3"
        style={{
          fontSize: "1.2rem",
          fontWeight: "bold",
          lineHeight: "1.3",
        }}
      >
        {item.title}
      </h4>

      {/* Description */}
      <p
        className="text-light mb-4"
        style={{
          fontSize: "0.9rem",
          lineHeight: "1.5",
          marginBottom: "1.5rem",
        }}
      >
        {item.description}
      </p>

      {/* Contact Info */}
      <button
        type="button"
        className="contact-detail text-info"
        style={{
          fontSize: "1rem",
          fontWeight: "600",
          cursor: "pointer",
          backgroundColor: "transparent",
          fontFamily: "inherit",
          transition: "all 0.3s ease",
          padding: "0.5rem",
          borderRadius: "8px",
          border: "2px solid transparent",
        }}
        onClick={handleContactClick}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = "rgba(23, 162, 184, 0.1)";
          e.target.style.borderColor = "#17a2b8";
          e.target.style.transform = "scale(1.05)";
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = "transparent";
          e.target.style.borderColor = "transparent";
          e.target.style.transform = "scale(1)";
        }}
        title={item.contact}
      >
        {item.contact}
      </button>
    </div>
  );
};

export default ContactOneInfoItem;
